import React from "react";
import PropsTypes from "prop-types";
import { FaArrowLeft } from 'react-icons/fa';
import { useNavigate } from "react-router-dom";
function Page({ title, children }) {

  const navigate = useNavigate();

  return (
    <React.Fragment>
      <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
        <div className="text-uppercase d-flex align-items-center">

          <div className="me-2" style={{ cursor: 'pointer' }}>
            <i className="p-1 bg-primary d-flex align-items-center rounded text-white" onClick={() => navigate(-1)}><FaArrowLeft fontSize={20} /></i>
          </div>

          <div className="text-primary fs-5 fw-bold">{title}</div>

        </div>
        <div className="btn-toolbar mb-2 mb-md-0">
          {/* <div className="btn-group me-2">
            <button type="button" className="btn btn-sm btn-outline-secondary">Share</button>
            <button type="button" className="btn btn-sm btn-outline-secondary">Export</button>
          </div> */}
        </div>
      </div>

      {children}
    </React.Fragment>
  );
}

export default Page;

Page.propTypes = {
  title: PropsTypes.string.isRequired,
  children: PropsTypes.node.isRequired,
};
